export default __webpack_public_path__ + "static/pala-77cb4b3e7bab1c5a5538395aa1aec8bf.jpeg";